export default function AuthUsed() {
  return (
    <div className="flex flex-col items-center justify-center min-h-screen px-4">
      <div className="text-center">
        <div className="text-6xl mb-4">&#128279;</div>
        <h1 className="text-3xl font-bold text-white mb-4">Link Already Used</h1>
        <p className="text-gray-400 max-w-md">
          This magic link has already been used. If you need to access the
          review again, please request a new link.
        </p>
      </div>
    </div>
  );
}
